import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { BaseService, ApiResult } from './base.service';
import { Observable } from 'rxjs';
import { OficinaFacturacion } from '../models/OficinaFacturacion';

@Injectable({
  providedIn: 'root'
})
export class OficinaFacturacionService {

  constructor(protected http: HttpClient, @Inject('BASE_URL') protected baseUrl: string) {

  }

  getData(pageIndex: number, pageSize: number, sortColumn: string,
    sortOrder: string, filterColumn: string, filterQuery: string): Observable<ApiResult<OficinaFacturacion>> {

    const url = this.baseUrl + 'api/OficinaFacturacion';

    let params = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('sortColumn', sortColumn)
      .set('sortOrder', sortOrder);

    if (filterQuery) {
      params = params
        .set('filterColumn', filterColumn)
        .set('filterQuery', filterQuery);
    }

    return this.http.get<ApiResult<OficinaFacturacion>>(url, { params });
  }

  get(id: number): Observable<OficinaFacturacion> {
    const url = `${this.baseUrl}api/OficinaFacturacion/${id}`;
    return this.http.get<OficinaFacturacion>(url);
  }

  put(item): Observable<OficinaFacturacion> {
    const url = `${this.baseUrl}api/OficinaFacturacion/${item.id}`;
    console.log("put: "+url);
    return this.http.put<OficinaFacturacion>(url, item);
  }

  post(item): Observable<OficinaFacturacion> {
    const url = `${this.baseUrl}api/OficinaFacturacion`;
    console.log("post: "+url);
    return this.http.post<OficinaFacturacion>(url, item);
  }

  delete(id: number) {
    const url = `${this.baseUrl}api/OficinaFacturacion/${id}`;
    return this.http.delete<OficinaFacturacion>(url);
  }

}
